import React from 'react';

import { Button } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';

import { LbInput } from '@infoods/lifebase-ui';

import classes from './FiltersRow.module.scss';
import { CoachListFilterFormValues } from '../../../../../../interfaces/coachList/CoachListFilters';
import { GridTableRow } from '../../../../../../../shared/components/table-components';

type FiltersRowProps = {
  isMobile: boolean;
};

const FiltersRow = ({ isMobile }: FiltersRowProps) => {
  const { control, reset } = useFormContext<CoachListFilterFormValues>();

  const inputGeneralProps = { control, variant: 'outlined', size: 'small' } as const;

  const handleReset = () => {
    reset();
  };

  const filterClasses = classNames(classes.container, {
    [classes.mobileLayout]: isMobile,
  });

  return (
    <GridTableRow variant="unstyled" customLayout={isMobile} className={filterClasses}>
      <LbInput {...inputGeneralProps} name="coachName" label="Coach Name" />
      <LbInput {...inputGeneralProps} name="entityName" label="Business Name" />
      <Button variant="outlined" fullWidth size="small" onClick={handleReset}>
        Clear All
      </Button>
    </GridTableRow>
  );
};

export { FiltersRow };
